import { render, staticRenderFns } from "./bannerForm.vue?vue&type=template&id=7b5e0ee2&scoped=true&"
import script from "./bannerForm.vue?vue&type=script&lang=js&"
export * from "./bannerForm.vue?vue&type=script&lang=js&"
import style0 from "./bannerForm.vue?vue&type=style&index=0&id=7b5e0ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5e0ee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5e0ee2')) {
      api.createRecord('7b5e0ee2', component.options)
    } else {
      api.reload('7b5e0ee2', component.options)
    }
    module.hot.accept("./bannerForm.vue?vue&type=template&id=7b5e0ee2&scoped=true&", function () {
      api.rerender('7b5e0ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/components/bannerForm.vue"
export default component.exports